<template>
  <div>
    <v-dialog v-model="collection.dialog" max-width="600px">
      <v-card color="card">
        <v-card-title>
          <span class="headline" v-if="!collection.bulk"
            >Add to Collection</span
          >
          <span class="headline" v-else
            >Add {{ collection.attachmentId.length }} items to Collection</span
          >
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            @keydown.enter="confirmCollection"
            autofocus
            v-model="collection.id"
            :items="collection.collections"
            :outlined="!$store.state.site.whitelabel"
            item-text="name"
            item-value="id"
            label="Collection"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="collection.dialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="confirmCollection">
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="itemDelete.modal" max-width="600px">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title class="text-h5"
          >Are you sure you want to delete this item?
        </v-card-title>
        <v-card-subtitle
          >You are deleting {{ itemDelete.item.attachment }}, it will be gone
          forever.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="itemDelete.modal = false"
            >Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="red darken-1"
            text
            @click="deleteItemConfirm()"
            >Delete
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit.modal" max-width="600px">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5"
            >Editing Item ({{ edit.item.originalFilename }})</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              class="rounded-xl"
              v-model="edit.item.name"
              :outlined="!$store.state.site.whitelabel"
              label="Name"
              required
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="edit.modal = false"
          >
            Close
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="editItemConfirm()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="!loading">
      <button
        style="display: none"
        v-shortkey="['shift', 'a']"
        @shortkey="openAddDialog"
      >
        Debug
      </button>
      <div v-if="!selected.length && supports.multiSelect" class="float-right">
        <slot name="multi-select-actions">
          <v-btn class="rounded-xl ml-2" text @click="selectAll()">
            <v-icon>mdi-plus</v-icon>&nbsp;Select all
          </v-btn>
        </slot>
      </div>
      <div v-if="selected.length && supports.multiSelect" class="float-right">
        <slot name="multi-select-actions-length" :selected="selected">
          <v-btn class="rounded-xl ml-2" text @click="selectAll()">
            <v-icon>mdi-plus</v-icon>&nbsp;Select all
          </v-btn>
          <v-btn class="rounded-xl ml-2" text @click="deselectAll()">
            <v-icon>mdi-close</v-icon>&nbsp;Unselect all
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="red darken-1"
            text
            @click="bulkDeleteConfirm()"
            ><v-icon>mdi-delete</v-icon> Delete Selected</v-btn
          >
          <v-btn class="rounded-xl ml-2" text @click="bulkAddCollection()">
            <v-icon>mdi-folder-multiple-image</v-icon>&nbsp;Add to Collection
          </v-btn>
        </slot>
      </div>
      <br /><br />
      <v-row>
        <v-col
          v-for="item in items.gallery"
          :key="'item-' + item.id"
          :md="$store.state.experiments['EXPERIENCE_GALLERY_ITEM_WIDTH']"
        >
          <v-card
            class="rounded-xl d-flex flex-column"
            elevation="8"
            :id="'item-' + item.id"
          >
            <v-toolbar
              v-if="supports.multiSelect"
              style="z-index: 1"
              @click="selected.length ? multiSelect(item) : null"
              :class="{ 'prevent-select': selected.length }"
            >
              <v-toolbar-title>{{ item.name }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- multi-select button -->
              <v-btn
                v-if="!$vuetify.breakpoint.mobile"
                icon
                @click.prevent.stop="multiSelect(item)"
              >
                <v-icon>{{
                  selected.includes(item.id)
                    ? "mdi-checkbox-marked-circle"
                    : "mdi-circle-outline"
                }}</v-icon>
              </v-btn>
            </v-toolbar>
            <v-toolbar v-else style="z-index: 1">
              <v-toolbar-title>{{ item.name }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <slot name="toolbar-actions" :item="item" />
            </v-toolbar>
            <v-hover v-slot="{ hover }">
              <v-img
                v-if="item.type === 'image'"
                :src="'https://uploader.electrics01.com/i/' + item.attachment"
                contain
                height="220"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
                <a
                  :href="'https://uploader.electrics01.com/i/' + item.attachment"
                  target="_blank"
                >
                  <v-fade-transition v-if="hover">
                    <v-overlay absolute>
                      <v-icon large>mdi-open-in-new</v-icon>
                    </v-overlay>
                  </v-fade-transition>
                </a>
              </v-img>
            </v-hover>
            <v-container v-if="item.type === 'video'">
              <video
                width="100%"
                height="298"
                v-if="item.type === 'video'"
                controls
              >
                <source
                  :src="'https://uploader.electrics01.com/i/' + item.attachment"
                  type="video/mp4"
                />
              </video>
            </v-container>
            <highlightjs
              v-if="
                item.type === 'paste' &&
                JSON.parse(item.data).paste.highlighting !== 'none' &&
                JSON.parse(item.data).paste.highlighting !== 'auto'
              "
              :code="JSON.parse(item.data).paste.content"
              :language="JSON.parse(item.data).paste.highlighting"
              class="lineRestrict text-left padding"
            />
            <highlightjs
              v-if="
                item.type === 'paste' &&
                JSON.parse(item.data).paste.highlighting === 'auto'
              "
              :code="JSON.parse(item.data).paste.content"
              autodetect
              class="text-left padding lineRestrict"
            />
            <highlightjs
              v-if="
                item.type === 'paste' &&
                JSON.parse(item.data).paste.highlighting === 'none'
              "
              :code="JSON.parse(item.data).paste.content"
              class="text-left padding lineRestrict"
              language="plaintext"
            />
            <h1
              v-if="
                item.type !== 'image' &&
                item.type !== 'video' &&
                item.type !== 'paste'
              "
              class="text-center"
              style="line-height: 220px"
            >
              No Preview
            </h1>
            <v-card-text>
              <div v-if="item.type">
                Type:
                {{
                  String(item.type).charAt(0).toUpperCase() +
                  String(item.type).slice(1)
                }}
              </div>

              <div v-else>Type: Binary</div>

              <div v-if="item.type === 'paste'">
                Language: {{ JSON.parse(item.data).paste.highlighting }}
              </div>

              <div v-if="item.type !== 'paste'">
                Original: {{ item.originalFilename }}
              </div>

              <div v-if="item.type !== 'paste'">
                Uploaded Name: {{ item.attachment }}
              </div>

              <div>
                Created at:
                {{ $date(item.createdAt).format("Do of MMMM YYYY, h:mm A") }}
              </div>
              <div v-if="item.type !== 'paste'">
                Filesize: {{ fileSize(item.fileSize) }}
              </div>
              <slot :item="item" name="custom-properties" />
              <v-chip-group>
                <HoverChip
                  text="Add to Collection"
                  icon="mdi-plus"
                  @click="addToCollection(item.id)"
                  v-if="permissions.write"
                >
                </HoverChip>
                <v-chip
                  :to="'/collections/' + collection.id"
                  :key="collection.id"
                  v-for="collection in item.collections"
                  :disabled="!$store.state.user.username"
                >
                  {{ collection.name }}
                  <v-icon
                    @click.prevent="removeItem(item, collection)"
                    class="ml-1"
                    v-if="permissions.write"
                    >mdi-close</v-icon
                  >
                </v-chip>
              </v-chip-group>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <v-card-text class="text-center">
              <slot name="actions" :item="item">
                <HoverChip
                  text="Edit"
                  icon="mdi-pencil"
                  color="indigo"
                  @click="editItem(item)"
                  v-if="permissions.write"
                ></HoverChip>
                <HoverChip
                  text="Delete"
                  icon="mdi-delete"
                  color="red"
                  @click="deleteItem(item)"
                  v-if="permissions.write"
                ></HoverChip>
                <HoverChip
                  text="Link"
                  icon="mdi-content-copy"
                  color="teal"
                  @click="copyLink(item)"
                ></HoverChip>
                <HoverChip
                  :text="item.type === 'paste' ? 'Raw' : 'Open'"
                  icon="mdi-open-in-new"
                  color="info"
                  :href="'https://uploader.electrics01.com/i/' + item.attachment"
                ></HoverChip>
                <HoverChip
                  text="OCR"
                  icon="mdi-ocr"
                  color="green"
                  @click="copy(item.textMetadata)"
                  v-if="item.type === 'image'"
                ></HoverChip>
                <HoverChip
                  text="Star"
                  :icon="item.starred ? 'mdi-star' : 'mdi-star-outline'"
                  color="amber darken-2"
                  @click="star(item)"
                  v-if="$store.state.user.username"
                ></HoverChip>
              </slot>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="justify-center align-center text-center mb-1">
        <v-pagination
          v-model="page"
          :length="items.pager.endPage"
          :total-visible="7"
        ></v-pagination>
      </v-row>
      <v-row no-gutters>
        <v-col cols="2">
          <v-text-field
            label="Page"
            v-shortkey.avoid
            type="number"
            min="1"
            :max="items.pager.totalItems"
            @keydown.enter="setPage($event)"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <small>
        Total Pages: {{ items.pager.totalPages }}
        <v-btn
          text
          style="float: right"
          @click="randomAttachment"
          v-if="supports.randomAttachment"
          >Random Attachment</v-btn
        >
        <br />
        Total Items: {{ items.pager.totalItems }}
      </small>
    </template>
    <template v-else>
      <v-overlay :value="loading" absolute class="text-center">
        <v-progress-circular indeterminate size="64"> </v-progress-circular>
      </v-overlay>
    </template>
  </div>
</template>

<script>
import HoverChip from "@/components/HoverChip"
import AjaxErrorHandler from "@/lib/errorHandler"
export default {
  name: "GalleryNext",
  components: {
    HoverChip
  },
  props: [
    "items",
    "setPage",
    "pageValue",
    "randomAttachment",
    "supports",
    "loading",
    "permissionsValue",
    "getItems"
  ],
  data() {
    return {
      selected: [],
      collection: {
        attachmentId: "",
        dialog: false,
        collections: [],
        id: 0,
        bulk: false
      },
      itemDelete: {
        modal: false,
        item: []
      },
      edit: {
        modal: false,
        item: []
      }
    }
  },
  computed: {
    permissions() {
      if (this.supports.permissions) {
        return this.permissionsValue
      } else {
        return {
          read: true,
          write: true,
          owner: true,
          joined: true,
          configure: true
        }
      }
    },
    page: {
      get() {
        return this.pageValue
      },
      set(value) {
        this.$emit("setPage", value)
      }
    }
  },
  methods: {
    star(item) {
      this.axios
        .post("/api/v1/stars/" + item.attachment)
        .then(() => {
          this.$toast.success("Action completed successfully.")
          item.starred = !item.starred
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    click() {
      return this.selected.length ? "click" : null
    },
    openAddDialog() {
      if (document.activeElement.tagName === "INPUT") return
      if (!this.selected?.length) return
      this.collection.dialog = true
    },
    selectAll() {
      this.selected.push(...this.items.gallery.map((item) => item.id))
    },
    deselectAll() {
      this.selected = []
    },
    bulkDeleteConfirm() {
      this.$toast.error("Not implemented yet")
    },
    bulkAddCollection() {
      if (this.collection.collections.length) {
        this.collection.attachmentId = this.selected
        this.collection.bulk = true
        this.collection.dialog = true
      }
      this.axios.get("/api/v1/collections?write=true").then((res) => {
        this.collection.collections = res.data.rows
        this.collection.attachmentId = this.selected
        this.collection.bulk = true
        this.collection.dialog = true
      })
    },
    multiSelect(item) {
      if (this.selected.includes(item.id)) {
        this.selected.splice(this.selected.indexOf(item.id), 1)
      } else {
        this.selected.push(item.id)
      }
    },
    copy(text) {
      navigator.clipboard.writeText(text)
      this.$toast.info("Copied to clipboard.")
    },
    copyLink(item) {
      if (this.$store.state.user.openGraph) {
        navigator.clipboard.writeText(
          "https://" +
            this.$store.state.user.domain.domain +
            this.$store.state.user.customPath +
            item.attachment
        )
      } else {
        navigator.clipboard.writeText(
          "https://" +
            this.$store.state.user.domain.domain +
            "/i/" +
            item.attachment
        )
      }
    },
    editItemConfirm() {
      this.axios
        .put("/api/v1/gallery/edit", {
          id: this.edit.item.id,
          name: this.edit.item.name
        })
        .then(() => {
          this.edit.modal = false
          this.edit.item = []
          this.getItems(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    editItem(item) {
      this.edit.item = item
      this.edit.modal = true
    },
    deleteItem(item) {
      this.itemDelete.item = item
      this.itemDelete.modal = true
    },
    deleteItemConfirm() {
      this.axios
        .post("/api/v1/gallery/delete", {
          id: this.itemDelete.item.id
        })
        .then(() => {
          this.itemDelete.modal = false
          this.itemDelete.item = []
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.$store.commit(
              "setDiscordCache",
              JSON.parse(res.data.discordUserCache)
            )
          })
          this.getItems(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    removeItem(item, collection) {
      this.axios
        .delete("/api/v1/collections/" + collection.id + "/remove/" + item.id)
        .then(() => {
          this.$toast.success("Removed from collection")
          this.items.gallery
            .find((i) => i.id === item.id)
            .collections.splice(
              this.items.gallery
                .find((i) => i.id === item.id)
                .collections.findIndex((c) => c.id === collection.id),
              1
            )
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    confirmCollection() {
      if (!this.collection.id) return
      if (this.collection.bulk) {
        this.axios
          .post("/api/v1/collections/attachment", {
            items: this.collection.attachmentId,
            collectionId: this.collection.id
          })
          .then(() => {
            for (const attachment of this.collection.attachmentId) {
              this.items.gallery
                .find((item) => item.id === attachment)
                .collections.push(
                  this.collection.collections.find(
                    (collection) => collection.id === this.collection.id
                  )
                )
            }
            /*if (this.show.selected === "nonCollectivized") {
              this.items.gallery = this.items.gallery.filter(
                (item) => !this.collection.attachmentId.includes(item.id)
              )
              this.getItems(false, false, true)
            }*/
            this.collection.bulk = false
            this.collection.dialog = false
            this.collection.attachmentId = 0
            this.collection.id = 0
            this.doSinglePulse("item-collected", {
              collectionId: this.collection.id,
              count: this.collection.attachmentId.length
            })
            this.selected = []
          })
          .catch((e) => {
            this.collection.bulk = false
            this.collection.dialog = false
            this.collection.attachmentId = 0
            this.collection.id = 0
            this.selected = []
            AjaxErrorHandler(this.$store)(e)
          })
        return
      }
      this.axios
        .post("/api/v1/collections/attachment", {
          attachmentId: this.collection.attachmentId,
          collectionId: this.collection.id
        })
        .then(() => {
          this.items.gallery
            .find((item) => item.id === this.collection.attachmentId)
            .collections.push(
              this.collection.collections.find(
                (collection) => collection.id === this.collection.id
              )
            )
          /*if (this.show.selected === "nonCollectivized") {
            this.items.gallery = this.items.gallery.filter(
              (item) => item.id !== this.collection.attachmentId
            )
            this.getItems(false, false, true)
          }*/
          this.collection.dialog = false
          this.collection.attachmentId = 0
          this.collection.id = 0
        })
        .catch((e) => {
          this.collection.dialog = false
          this.collection.attachmentId = 0
          this.collection.id = 0
          AjaxErrorHandler(this.$store)(e)
        })
      this.doSinglePulse("item-collected", {
        collectionId: this.collection.id,
        count: 1
      })
    },
    doSinglePulse(type, other, timeOnPage) {
      this.$socket.emit("pulse", {
        action: type,
        timeSpent: timeOnPage || 0,
        route: this.$route.path,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other
      })
    },
    addToCollection(id) {
      this.collection.bulk = false
      if (this.collection.collections.length) {
        this.collection.attachmentId = id
        this.collection.dialog = true
      }
      this.axios.get("/api/v1/collections?write=true").then((res) => {
        this.collection.collections = res.data.rows
        this.collection.attachmentId = id
        this.collection.dialog = true
      })
    }
  }
}
</script>

<style scoped></style>
